import { PartialMessageConstructor } from '@zg-rentals/backend-styled-components';
import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type UpdateActiveStatusProps = {
  partialMessages?: Array<PartialMessageProps>;
  isAllowed?: boolean;
  messageCode?: string;
  showRestrictionOnDashboard?: boolean;
};

const UpdateActiveStatus = ({
  partialMessages = [],
  isAllowed = true,
  messageCode = '',
  showRestrictionOnDashboard = false,
}: Partial<UpdateActiveStatusProps> = {}) => ({
  partialMessages: partialMessages.map((p) => PartialMessageConstructor(p)),
  isAllowed: Boolean(isAllowed),
  messageCode: String(messageCode),
  showRestrictionOnDashboard: Boolean(showRestrictionOnDashboard),
});

export default UpdateActiveStatus;
